<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import { computed, inject } from 'vue';
import { useTerraStore } from '~/terra/store/terra.store.js';
import { useFeatureActions } from '~/terra/utils/feature-actions.composable.js';

const emits = defineEmits(['close']);

const $t = inject('$t');

const terra_store = useTerraStore();
const { getSelectedFeaturesLatestVolume, exportVolumeHistory } = useFeatureActions();

const volume_calculation_columns = computed(() => ([
  {
    header: $t('Name'),
    accessorKey: 'feature_name',
    id: 'feature_name',
    size: 160,
  },
  {
    header: $t('Date'),
    accessorKey: 'date',
    id: 'date',
    size: 100,
  },
  {
    header: $t('Type'),
    accessorKey: 'layer',
    id: 'layer',
    size: 60,
  },
  {
    header: $t('Method'),
    accessorKey: 'method',
    id: 'method',
    size: 140,
  },
  {
    header: $t('Cut'),
    accessorKey: 'cut',
    id: 'cut',
    size: 80,
  },
  {
    header: $t('Fill'),
    accessorKey: 'fill',
    id: 'fill',
    size: 80,
  },
  {
    header: $t('Total'),
    accessorKey: 'total',
    id: 'total',
    size: 80,
  },
  {
    header: $t('Height'),
    accessorKey: 'height',
    id: 'height',
    size: 80,
  },
  {
    header: $t('Net'),
    accessorKey: 'net',
    id: 'net',
    size: 80,
  },
]));

const volume_calculation_history = computed(() => {
  return getSelectedFeaturesLatestVolume(terra_store.selected_features);
});
</script>

<template>
  <hawk-modal-container content_class="rounded-lg !w-[1000px] !max-w-[90vw]">
    <hawk-modal-header @close="emits('close')">
      <template #title>
        {{ $t('Volume Calculation') }}
      </template>
      <template #right>
        <HawkButton type="outlined" @click="exportVolumeHistory">
          {{ $t('Export') }}
        </HawkButton>
      </template>
    </hawk-modal-header>
    <hawk-modal-content>
      <div v-if="volume_calculation_history.length" class="w-full scrollbar">
        <HawkTable
          :data="volume_calculation_history"
          :columns="volume_calculation_columns"
          :manual_pagination="true"
          :show_menu_header="false"
          :header_grid_lines="{
            horizontal: true,
            vertical: true,
          }"
          :data_grid_lines="{
            horizontal: true,
            vertical: true,
          }"
          is_gapless
          disable_resize
          :is_pagination_enabled="false"
        />
      </div>
      <div v-else class="text-sm text-gray-500 text-center py-8">
        {{ $t('No volume calculation data available') }}
      </div>
    </hawk-modal-content>
  </hawk-modal-container>
</template>

<style lang="scss" scoped>
  :deep() {
    th {
      font-weight: 600;
      padding: 12px 8px !important;
    }
    td {
      padding: 12px 8px !important;
    }
    tr:last-child  {
      td:first-child{
        border-bottom-left-radius: 8px;
      }
      td:last-child {
        border-bottom-right-radius: 8px;
      }
    }
  }
</style>
